<template>
  <div id="main">
    <!-- ======= Resume Section ======= -->
    <section id="resume" class="resume">
      <div class="container">
        <div class="section-title">
          <h2 class="clearfix">Resume</h2>
          <div class="previous-section float-left">
            <a
              name=""
              id=""
              class="btn btn-primary d-xl-none"
              href="/about"
              role="button"
              >Go to Previous Section</a
            >
          </div>
          <div class="next-section float-right">
            <a
              name=""
              id=""
              class="btn btn-primary d-xl-none"
              href="/portfolio"
              role="button"
              >Go to Next Section</a
            >
          </div>
          <p>
            Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex
            aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos
            quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia
            fugiat sit in iste officiis commodi quidem hic quas.
          </p>
        </div>

        <div class="row">
          <div class="col-lg-6" data-aos="fade-up">
            <h3 class="resume-title">Education</h3>
            <div class="resume-item">
              <h4>Data Analysis with Python: Zero to Pandas</h4>
              <h5>2020</h5>
              <p><em>Jovian.Ml</em></p>
            </div>
            <div class="resume-item">
              <h4>Bachelor of Science in Economics</h4>
              <h5>2015 - 2019</h5>
              <p><em>Adekunle Ajasin University, Akungba-Akoko</em></p>
            </div>
          </div>
          <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <h3 class="resume-title">Professional Experience</h3>
            <div class="resume-item">
              <h4>Freelancer</h4>
              <h5>2020</h5>
              <p><em>Jotweb</em></p>
            </div>
            <div class="resume-item">
              <h4>Full stack Web Developer</h4>
              <h5>2017-2019</h5>
              <p><em>Carina Based Tutor, Lagos, Nigeria </em></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Resume Section -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {}
};
</script>
